export enum PaymentFlowType {
  DEFAULT = 'default-payment',
  FINISH_PAYMENT = 'finish-payment',
  ADDITIONAL_PAYMENT = 'additional-payment'
}
